// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"LanguageSwitcher_btnWrapper__M5f37","btnEng":"LanguageSwitcher_btnEng__2Clnf","btnSv":"LanguageSwitcher_btnSv__VvZ_C"};